import { FC } from 'react';
import { Switch, Button } from 'antd';
import Iconfont from '@base/lib/Iconfont';
import site from 'pro/config/site';
import { IGoogleConsentPopupInstance } from 'mod/track/GoogleConsent/useGoogleConsentPopup';
import { Trans, useTrans } from 'base/utils/i18n';
import { IconMinus, IconPlus } from '@base/icon';
import { Collapse } from '@base/lib/Collapse';

type ICustomiseContentProps = IGoogleConsentPopupInstance & {
    showOptions?: boolean;
};

export const CustomiseContent: FC<ICustomiseContentProps> = props => {
    const {
        preferencesChecked,
        setPreferencesChecked,
        advertisingChecked,
        setAdvertisingChecked,
        onConfirmChoice,
        openHelpPopup,
        showOptions = true,
    } = props;

    const { t } = useTrans();

    return (
        <>
            <div className={'g-desc'}>
                <Trans i18nKey={'web_consent_customise_desc'} components={{ privacy: <span className={'g-help-link'} onClick={openHelpPopup}/> }}/>
            </div>

            <Collapse
                list={[
                    {
                        key: 'necessary',
                        title: t('web_consent_customise_necessary_title'),
                        extra: t('web_consent_customise_always_on'),
                        body: <Trans i18nKey={'web_consent_customise_necessary_desc'} components={{ privacy: <span className={'g-help-link'} onClick={openHelpPopup}/> }}/>
                    },
                    {
                        key: 'preferences',
                        title: t('web_consent_customise_preferences_title'),
                        extra: (
                            <Switch
                                className={'g-switch'}
                                checked={preferencesChecked}
                                onChange={setPreferencesChecked}
                                onClick={(_, e) => e.stopPropagation()}
                            />
                        ),
                        body: <Trans i18nKey={'web_consent_customise_preferences_desc'} components={{ privacy: <span className={'g-help-link'} onClick={openHelpPopup}/> }}/>
                    },
                    {
                        key: 'advertising',
                        title: t('web_consent_customise_advertising_title'),
                        extra: (
                            <Switch
                                className={'g-switch'}
                                checked={advertisingChecked}
                                onChange={setAdvertisingChecked}
                                onClick={(_, e) => e.stopPropagation()}
                            />
                        ),
                        body: t('web_consent_customise_advertising_desc', { brand: site.brand })
                    },
                ].map(item => ({
                    ...item,
                    expandIconPosition: 'left',
                    expandIcon: isActive => {
                        if ('iconfont' in site) {
                            return (
                                <Iconfont className={isActive ? 'icon-minus' : 'icon-add'}/>
                            )
                        }
                        return isActive ? <IconPlus size={false}/> : <IconMinus size={false}/>
                    }
                }))}
            />

            {showOptions && (
                <div className={'g-cus-options'}>
                    <Button
                        type={'primary'}
                        onClick={onConfirmChoice}
                        className={'g-cus-confirm'}
                    >
                        {t('web_consent_customise_confirm_my_choice')}
                    </Button>
                </div>
            )}
        </>
    )
};
